import { render, staticRenderFns } from "./RouterBack.vue?vue&type=template&id=50aefa25"
import script from "./RouterBack.vue?vue&type=script&lang=js"
export * from "./RouterBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports